import { deleteDoc, doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

const formatTimestamp = (value) => {
  if (value?.toDate) {
    return value.toDate().toLocaleString("tr-TR");
  }

  if (value) {
    const parsed = new Date(value);
    if (!Number.isNaN(parsed.getTime())) return parsed.toLocaleString("tr-TR");
  }

  return "-";
};

function ArchivedProjectsView({
  pendingArchiveProjects = [],
  filteredArchivedProjects,
  archivedSearchText,
  setArchivedSearchText,
  isAdmin = false,
  approveProjectArchive,
  rejectProjectArchive,
  currentUserEmail = "",
  themeMode = "light"
}) {
  const isDark = themeMode === "dark";
  const colors = {
    text: isDark ? "#e5edf6" : "#111827",
    muted: isDark ? "#9ca3af" : "#64748b",
    panel: isDark ? "#162235" : "#ffffff",
    panel2: isDark ? "#101b2d" : "#f8fafc",
    border: isDark ? "#2c3d55" : "#e2e8f0",
    input: isDark ? "#101827" : "#ffffff"
  };
  const requesterEmail = String(currentUserEmail || "").trim().toLowerCase();

  return (
    <div style={{ color: colors.text }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
        <div>
          <h2 style={{ margin: 0 }}>Proje Arşivi</h2>
          <div style={{ marginTop: 5, color: colors.muted, fontSize: 13 }}>
            Arşivleme taleplerini ve arşivlenen projeleri yönetin.
          </div>
        </div>
      </div>

      <input
        placeholder="Firma, proje adı, teknopark veya STB kodu ara..."
        value={archivedSearchText}
        onChange={(e) => setArchivedSearchText(e.target.value)}
        style={{
          width: "100%",
          padding: "14px 18px",
          marginTop: 18,
          marginBottom: 20,
          borderRadius: 14,
          border: `1px solid ${colors.border}`,
          background: colors.input,
          color: colors.text,
          fontSize: 14,
          outline: "none",
          boxSizing: "border-box",
          boxShadow: isDark ? "0 10px 24px rgba(0,0,0,0.15)" : "0 4px 12px rgba(0,0,0,0.04)"
        }}
      />

      <section
        style={{
          padding: 18,
          borderRadius: 16,
          border: `1px solid ${isDark ? "#854d0e" : "#fcd34d"}`,
          background: isDark ? "#2a2112" : "#fffbeb",
          marginBottom: 24
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", gap: 12, alignItems: "center", marginBottom: pendingArchiveProjects.length ? 14 : 0 }}>
          <div>
            <h3 style={{ margin: 0, color: isDark ? "#fde68a" : "#92400e" }}>
              Admin Onayı Bekleyen Talepler
            </h3>
            <div style={{ marginTop: 4, color: isDark ? "#d6b868" : "#a16207", fontSize: 13 }}>
              Projeler admin onayı verilene kadar aktif listede kalır.
            </div>
          </div>
          <span
            style={{
              minWidth: 30,
              height: 30,
              padding: "0 9px",
              borderRadius: 999,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#f59e0b",
              color: "#fff",
              fontWeight: 900
            }}
          >
            {pendingArchiveProjects.length}
          </span>
        </div>

        {pendingArchiveProjects.map((project) => {
          const isOwnRequest =
            String(project.archiveRequestedBy || "").trim().toLowerCase() === requesterEmail;

          return (
            <div
              key={project.id}
              style={{
                padding: 16,
                borderRadius: 14,
                border: `1px solid ${colors.border}`,
                background: colors.panel,
                marginTop: 10
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  gap: 16,
                  flexWrap: "wrap"
                }}
              >
                <div style={{ flex: "1 1 520px", minWidth: 0 }}>
                  <strong>
                    {project.firmaAdi} - {project.projeAdi}
                  </strong>
                  <div style={{ marginTop: 6, color: colors.muted, fontSize: 13 }}>
                    {project.teknoparkAdi || "-"} • {project.projeStbKodu || "-"}
                  </div>
                  <div
                    style={{
                      marginTop: 12,
                      padding: "11px 13px",
                      borderRadius: 10,
                      background: colors.panel2,
                      border: `1px solid ${colors.border}`,
                      lineHeight: 1.5
                    }}
                  >
                    <div style={{ color: colors.muted, fontSize: 11, fontWeight: 900, textTransform: "uppercase" }}>
                      Arşivleme gerekçesi
                    </div>
                    <div style={{ marginTop: 4, fontWeight: 700 }}>
                      {project.archiveReason || "-"}
                    </div>
                  </div>
                  <div style={{ marginTop: 9, color: colors.muted, fontSize: 12 }}>
                    Talep eden: {project.archiveRequestedBy || "-"}
                    {isOwnRequest ? " (Siz)" : ""} • Tarih: {formatTimestamp(project.archiveRequestedAt)}
                  </div>
                </div>

                {isAdmin ? (
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, flex: "0 0 245px" }}>
                    <button
                      type="button"
                      onClick={() => rejectProjectArchive?.(project)}
                      style={{
                        padding: "10px 13px",
                        borderRadius: 10,
                        border: "1px solid #ef4444",
                        background: "transparent",
                        color: "#ef4444",
                        fontWeight: 800,
                        cursor: "pointer"
                      }}
                    >
                      Reddet
                    </button>
                    <button
                      type="button"
                      onClick={() => approveProjectArchive?.(project)}
                      style={{
                        padding: "10px 13px",
                        borderRadius: 10,
                        border: "none",
                        background: "#16a34a",
                        color: "#fff",
                        fontWeight: 800,
                        cursor: "pointer"
                      }}
                    >
                      Onayla
                    </button>
                  </div>
                ) : (
                  <span style={{ color: "#b45309", fontWeight: 800, fontSize: 13 }}>
                    Admin onayı bekleniyor
                  </span>
                )}
              </div>
            </div>
          );
        })}

        {pendingArchiveProjects.length === 0 && (
          <div style={{ color: isDark ? "#d6b868" : "#a16207", fontWeight: 700 }}>
            Onay bekleyen arşivleme talebi bulunmuyor.
          </div>
        )}
      </section>

      <section>
        <div style={{ display: "flex", justifyContent: "space-between", gap: 12, alignItems: "center", marginBottom: 12 }}>
          <h3 style={{ margin: 0 }}>Arşivlenen Projeler</h3>
          <span style={{ color: colors.muted, fontWeight: 800 }}>
            {filteredArchivedProjects.length} proje
          </span>
        </div>

        <div style={{ display: "grid", gap: 12 }}>
          {filteredArchivedProjects.map((project) => (
            <div
              key={project.id}
              style={{
                background: colors.panel,
                border: `1px solid ${colors.border}`,
                borderRadius: 14,
                padding: 18,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 16,
                flexWrap: "wrap"
              }}
            >
              <div style={{ minWidth: 0 }}>
                <strong>{project.firmaAdi} - {project.projeAdi}</strong>
                <div style={{ marginTop: 6, fontSize: 14, color: colors.muted }}>
                  {project.teknoparkAdi || "-"} • {project.projeStbKodu || "-"}
                </div>
                <div style={{ marginTop: 6, fontSize: 13, color: colors.muted }}>
                  Talep eden: {project.archiveRequestedBy || "-"} • Onaylayan: {project.archiveApprovedBy || project.archivedBy || "-"}
                  {" "}• Tarih: {formatTimestamp(project.archivedAt)}
                </div>
                {project.archiveReason && (
                  <div style={{ marginTop: 7, color: colors.muted, fontSize: 13 }}>
                    Gerekçe: {project.archiveReason}
                  </div>
                )}
              </div>

              {isAdmin && (
                <div style={{ display: "flex", gap: 10 }}>
                  <button
                    onClick={async () => {
                      const confirmed = await window.appConfirm(
                        "Bu proje tekrar aktif proje listesine alınsın mı?",
                        { title: "Projeyi geri al", type: "warning", confirmText: "Geri Al" }
                      );
                      if (!confirmed) return;

                      await updateDoc(doc(db, "projects", project.id), {
                        isArchived: false,
                        archiveApprovalStatus: "restored",
                        archiveRestoredAt: serverTimestamp(),
                        archiveRestoredBy: currentUserEmail || ""
                      });

                      alert("Proje arşivden geri alındı.");
                    }}
                    style={{
                      padding: "10px 16px",
                      borderRadius: 10,
                      border: "none",
                      background: "#2563eb",
                      color: "#fff",
                      fontWeight: 700,
                      cursor: "pointer"
                    }}
                  >
                    Geri Al
                  </button>

                  <button
                    onClick={async () => {
                      const confirmDelete = await window.appConfirm(
                        "Bu projeyi kalıcı olarak silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
                        { title: "Kalıcı silme", type: "danger", confirmText: "Kalıcı sil" }
                      );

                      if (!confirmDelete) return;
                      await deleteDoc(doc(db, "projects", project.id));
                      alert("Proje kalıcı olarak silindi.");
                    }}
                    style={{
                      padding: "10px 16px",
                      borderRadius: 10,
                      border: "none",
                      background: "#ef4444",
                      color: "#fff",
                      fontWeight: 700,
                      cursor: "pointer"
                    }}
                  >
                    Kalıcı Sil
                  </button>
                </div>
              )}
            </div>
          ))}

          {filteredArchivedProjects.length === 0 && (
            <div
              style={{
                padding: 20,
                background: colors.panel,
                border: `1px solid ${colors.border}`,
                borderRadius: 14,
                color: colors.muted
              }}
            >
              Arşivlenmiş proje bulunmuyor.
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default ArchivedProjectsView;
